var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"reference",on:{"click":function($event){return _vm.$emit('show-tab-ref')}}},[_vm._v(" ("+_vm._s(_vm.reference.author)),(_vm.page)?_c('span',[_vm._v(", "+_vm._s(_vm.page))]):_vm._e(),_vm._v(")")])}
var staticRenderFns = []

export { render, staticRenderFns }